import React from 'react';
import { Root, StyledCheckIcon } from './Checkbox.styled.js';
/**
 * Use `Checkbox` to control binary value in the form
 */
export const Checkbox = ({ name, id, inputRef, value, defaultValue, onChange, onClick, onFocus, onBlur, isDisabled = false, validationState = false, className, rootProps, inputProps, }) => {
    const handleOnChange = (event) => onChange?.(event.currentTarget.checked, event);
    return (React.createElement(Root, { onClick: onClick, isChecked: !!value, isDisabled: isDisabled, hasError: validationState === 'error', className: className, ...rootProps },
        React.createElement("input", { name: name, "data-test": "checkbox", id: id, type: "checkbox", value: String(value), checked: value, defaultChecked: defaultValue, "aria-checked": value, disabled: isDisabled, onChange: handleOnChange, onFocus: onFocus, onBlur: onBlur, ref: inputRef, ...inputProps }),
        React.createElement(StyledCheckIcon, null)));
};
//# sourceMappingURL=Checkbox.js.map